import { AlignType, RadioSelector, SelectorGroup } from '@outdoorsyco/bonfire';
import React from 'react';

import { EGuidedSearchComponentType, TGuidedSearchComponentField } from './types';

type TUpscaleGuidedSearchComponentFieldProps = TGuidedSearchComponentField & {
  value?: string | string[];
  onChange: (value?: string | string[]) => void;
};

const radioStyles = `
  .upscale-stacked-radio [role=radiogroup] > div {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }

  .upscale-grid-radio [role=radiogroup] > div {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .upscale-pill-root,
  .upscale-pill-root * {
    border: 0 !important;
    outline: 0 !important;
    --tw-ring-shadow: none !important;
    --tw-ring-width: 0 !important;
  }

  .upscale-pill-root {
    border-radius: 9999px !important;
    overflow: hidden;
    box-shadow: inset 0 0 0 1px #212831 !important;
    transition: box-shadow 0.2s ease, background-color 0.2s ease;
    cursor: pointer;
  }

  .upscale-pill-root:hover {
    background-color: #284941 !important;
    box-shadow: inset 0 0 0 1px #284941 !important;
  }

  .upscale-pill-root:hover .upscale-pill-content {
    color: #FFFFFF !important;
  }

  .upscale-pill-root--selected {
    background-color: #284941 !important;
    box-shadow: none !important;
  }

  .upscale-pill-root--selected:hover {
    box-shadow: none !important;
  }

  .upscale-pill-content {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;
    height: 100% !important;
    padding: 0.75rem 1.5rem !important;
    box-sizing: border-box;
    border-radius: 9999px !important;
    background-color: transparent !important;
    color: #000000 !important;
    box-shadow: none !important;
    font-family: 'Brother-1816', sans-serif;
    font-size: 2.5rem;
    font-weight: 500;
    line-height: 120%;
    cursor: pointer;
  }

  .upscale-pill-content--selected {
    color: #FFFFFF !important;
  }

  @media (min-width: 1024px) {
    .upscale-pill-content {
      font-size: 3rem;
    }
  }

  .upscale-pill-content span {
    pointer-events: none;
  }
`;

export const UpscaleGuidedSearchComponentField = ({
  id,
  component_type,
  properties: { rows = [], title, description },
  value,
  onChange,
}: TUpscaleGuidedSearchComponentFieldProps) => {
  if (component_type === EGuidedSearchComponentType.ButtonGroupRadio) {
    const filteredRows =
      id === 'where-are-you-traveling'
        ? rows.filter(row => row.label.toLowerCase() !== 'other')
        : rows;
    const isSmallGroup = filteredRows.length <= 2;
    const wrapperClass = isSmallGroup ? 'upscale-stacked-radio' : 'upscale-grid-radio';

    return (
      <>
        <style dangerouslySetInnerHTML={{ __html: radioStyles }} />
        <div className="flex flex-col w-full gap-3">
          {title && (
            <div className="text-xl font-semibold leading-relaxed text-gray-900">{title}</div>
          )}
          <div className={wrapperClass}>
            <SelectorGroup
              ariaLabel={description}
              value={(value as string) || ''}
              onChange={onChange as (value: string) => void}>
              {filteredRows.map(row => {
                const isSelected = (value as string) === row.id;
                return (
                  <RadioSelector
                    key={row.id}
                    name={row.id}
                    value={row.id}
                    ariaLabel={row.label}
                    label={row.label}
                    alignVariant={AlignType.VerticalCenter}
                    showIndicator={false}
                    withBorder={false}
                    className={
                      isSelected
                        ? 'upscale-pill-root upscale-pill-root--selected'
                        : 'upscale-pill-root'
                    }
                    contentWrapperClassName={`upscale-pill-content${isSelected ? ' upscale-pill-content--selected' : ''}`}
                  />
                );
              })}
            </SelectorGroup>
          </div>
        </div>
      </>
    );
  }

  return null;
};
